module.exports = function (Component) {
  Component.options.__i18n = Component.options.__i18n || []
  Component.options.__i18n.push('{"en":{"close_notification":"CLOSE"},"ja":{"close_notification":"閉じる"}}')
  delete Component.options._Ctor
}
